import { alpha, Box } from '@mui/material';
import React, { useState } from 'react';
import { AlertRuleScreenProps } from 'components/alert-rule-popup/index';
import { useTranslation } from 'react-i18next';
import FormStaticInfo from 'components/common/form/layout/static/FormStaticInfo';
import { FormDataAPIType, RawFormComponentType } from 'components/common/form';
import AlertRuleMethod from 'components/alert-rule-popup/parts/AlertRuleMethod';
import { prepareFormElementProps } from 'components/common/form/formTools';
import useCustomSimplifiedForm from 'components/common/form/hooks/useCustomSimplifiedForm';

interface AlertRuleScreenMethodProps extends AlertRuleScreenProps {
    onChange?: (text: any) => void;
}

export default function AlertRuleScreenMethod(props: AlertRuleScreenMethodProps) {
    const { wizardData } = props;
    const [methodDescHtmlText, setMethodDescHtmlText] = useState<any>();
    const { t } = useTranslation(['components/alert-rule-popup/alert_rule_popup']);
    const elementProps: FormDataAPIType = useCustomSimplifiedForm();

    if (!wizardData.isGlobal) return null;

    return (
        <Box>
            <Box
                sx={{
                    border: '1px solid',
                    borderColor: (theme) => alpha(theme.palette.text.primary, 0.08),
                    padding: 1.5,
                    backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.02),
                    borderRadius: '4px',
                }}
            >
                <AlertRuleMethod
                    onChange={(newVal) => {
                        setMethodDescHtmlText(newVal);
                    }}
                    {...props}
                />
            </Box>

            {wizardData.isShowWarningAlertRulePhone && (
                <Box sx={{ mt: 2 }}>
                    <FormStaticInfo
                        elementProps={prepareFormElementProps({
                            ...elementProps,
                            component: {
                                label: t('form.method.warning_alert_rule_phone'),
                                props: {
                                    type: 'error',
                                },
                            } as RawFormComponentType,
                        })}
                    />
                </Box>
            )}

            <Box
                sx={{
                    border: '1px solid',
                    borderColor: (theme) => alpha(theme.palette.text.primary, 0.08),
                    px: 1.5,
                    py: 1,
                    backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.02),
                    borderRadius: '4px',
                    mt: 2,
                }}
            >
                <Box
                    sx={{
                        '.mark': {
                            color: 'error.main',
                        },
                    }}
                    dangerouslySetInnerHTML={{ __html: methodDescHtmlText }}
                />
            </Box>
        </Box>
    );
}
